__turbopack_context__.v({
  "graffiti": "style-module-scss-module__exoKiG__graffiti",
  "title": "style-module-scss-module__exoKiG__title",
  "wrapper": "style-module-scss-module__exoKiG__wrapper",
});
